/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
// import CustomAlert from 'components/alerts/CustomAlert';
import Avatar from 'components/base/Avatar';
import Button from 'components/base/Button';
import PageLoader from 'components/custom/animate-component/PageLoader';
import LabelSelector from 'components/custom/forms/LabelSelector';
import Icon from 'components/icon';
import apiEndpoints from 'constants/apiEndpoints';
import { useFormik } from 'formik';
import useFetchData from 'hooks/custom/useFetchData';
import { useAlert } from 'providers/AlertModalProvider';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
// import postData from 'services/postData';
import fetchData from 'services/fetchData';
import postData from 'services/postData';
import * as Yup from 'yup';
import { findIndividual } from 'services/utils';
import CreateQuickTrucker from 'views/payment/quick-payment/CreateQuickTrucker';
import CreateQuickVehicle from 'views/payment/quick-payment/CreateQuickVehicle';
import CreateQuickDriver from 'views/payment/quick-payment/CreateQuickDriver';

const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    /* max-width: 300px !important; */
    margin-right: auto;

    margin-left: auto;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;

const CreateQuickTruckerVehicleDriver = ({
  show,
  handleClose,
  handleSelect,
  defaultData,
  fetchLoading = false
}) => {
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();
  const [activeTab, setActiveTab] = useState('AllData');
  const [truckerId, setTruckerId] = useState('');
  const [vehicleId, setVehicleId] = useState('');
  const [vehicleOption, setVehicleOption] = useState([]);
  const [driverOptions, setDriverOptions] = useState([]);
  const { 0: truckerOption, 3: refreshTrucker } = useFetchData(
    apiEndpoints.trucker.getAssignedTruckers
  );
  const [isDefaultFetch, setIsDefaultFetch] = useState(false);

  const formik = useFormik({
    initialValues: {
      driver_id: defaultData?.driver_id || '',
      vehicle_id: defaultData?.vehicle_id || '',
      trucker_id: defaultData?.trucker_id || ''
    },
    validationSchema: Yup.object({
      driver_id: Yup.string().required('Please select Driver'),
      vehicle_id: Yup.string().required('Please select Vehicle'),
      trucker_id: Yup.number().required('Please select Trucker'),
      challan_id: Yup.string()
    }),

    onSubmit: async values => {
      setLoading(true);
      try {
        if (values) {
          handleSelect(values);
        } else {
          showAlert({
            variant: 'danger',
            message: 'Failed to Assign Driver.'
          });
        }
      } catch (error) {
        showAlert({
          variant: 'danger',
          message: 'An unexpected error occurred. Please try again.'
        });
      } finally {
        setLoading(false);
      }
    }
  });

  const fetchVehicle = async id => {
    const response = await fetchData(
      apiEndpoints.vehicle.getVehicleByTrucker(id)
    );

    if (response.status) {
      const fetchedData = response.data;
      setVehicleOption(fetchedData);
    } else {
      setVehicleOption([]);
    }
  };

  const fetchDriver = async id => {
    const response = await fetchData(
      apiEndpoints.driver.getDriverFromVehicle(id)
    );

    if (response.status) {
      const fetchedData = response.data;
      setDriverOptions(fetchedData?.vehicles);
    } else {
      setDriverOptions([]);
    }
  };

  useEffect(() => {
    if (defaultData?.trucker_id && !isDefaultFetch) {
      fetchVehicle(defaultData?.trucker_id);
      fetchDriver(defaultData?.trucker_id);
      setIsDefaultFetch(true);
    }
  }, [defaultData, isDefaultFetch]);

  return (
    <>
      <CustomModal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        {activeTab == 'AllData' ? (
          <>
            <Modal.Header
              className="border-0 position-relative pb-0 end-0 dark__text-white"
              closeButton={!loading}
            >
              <div className="d-flex align-items-center mb-2">
                <Avatar size="xl" variant="name" className="me-2">
                  <Icon icon={'icon-park-outline:add-user'} fontSize="18px" />
                </Avatar>
                Quick Create
              </div>
            </Modal.Header>

            <Modal.Body className="pt-2 position-relative">
              <Row className="justify-content-center">
                <Col xs={12} sm={8} md={8} lg={8} className="mt-2">
                  <LabelSelector
                    placeholder={'Select Trucker'}
                    label={'Trucker'}
                    errorProps={{ tooltip: false }}
                    options={{
                      data: truckerOption,
                      formatter: option => ({
                        label: `${option.trucker_name}`,
                        value: option.trucker_id,
                        desc: `type - ${option.trucker_type}`
                      })
                    }}
                    callbackOnChange={opt => {
                      const selectedV = findIndividual(
                        truckerOption,
                        'trucker_id',
                        opt.value
                      );
                      fetchVehicle(selectedV.trucker_id);
                      setTruckerId(selectedV.trucker_id);
                      formik.setFieldValue('driver_id', '');
                      formik.setFieldValue('vehicle_id', '');
                    }}
                    controlId={'trucker_id'}
                    formik={formik}
                    required
                    allowFooter={true}
                    footerTextBtn={(search, _, setSearch) => (
                      <Button
                        className="text-decoration-none px-3 w-100 text-start"
                        onClick={() => setActiveTab('createTrucker')}
                        variant="link"
                      >
                        <Icon
                          icon={'flowbite:circle-plus-solid'}
                          className="me-1"
                          fontSize={'16px'}
                        />
                        Add New
                      </Button>
                    )}
                  />
                </Col>

                <Col xs={12} sm={8} md={8} lg={8} className="mt-3">
                  <LabelSelector
                    inputProps={{ disabled: !formik.values.trucker_id }}
                    placeholder={'Select Vehicle'}
                    label={'Vehicle'}
                    errorProps={{ tooltip: false }}
                    options={{
                      data: vehicleOption,
                      formatter: option => ({
                        label: `${option.vehicle_number}`,
                        value: option.vehicle_id,
                        desc: option.driver_name
                          ? `assigned to ${option.driver_name}`
                          : ''
                      })
                    }}
                    callbackOnChange={opt => {
                      const selectedV = findIndividual(
                        vehicleOption,
                        'vehicle_id',
                        opt.value
                      );
                      setVehicleId(selectedV.vehicle_id);

                      fetchDriver(formik.values.trucker_id);
                      formik.setFieldValue('driver_id', selectedV?.driver_id);
                      // formik.setFieldValue(
                      //   'driver_name',
                      //   selectedV?.driver_name
                      // );

                      // formik.setFieldValue(
                      //   'driver_upi_name',
                      //   selectedV?.driver_upi_name || ''
                      // );
                      // formik.setFieldValue(
                      //   'driver_upi_id',
                      //   selectedV?.driver_upi_id || ''
                      // );
                      // formik.setFieldValue(
                      //   'driver_mobile',
                      //   selectedV?.driver_mobile || ''
                      // );
                    }}
                    controlId={'vehicle_id'}
                    // controlLabelId={'vehicle_number'}
                    formik={formik}
                    required
                    allowFooter={true}
                    footerTextBtn={(search, _, setSearch) => (
                      <Button
                        className="text-decoration-none px-3 w-100 text-start"
                        onClick={() => setActiveTab('createVehicle')}
                        variant="link"
                      >
                        <Icon
                          icon={'flowbite:circle-plus-solid'}
                          className="me-1"
                          fontSize={'16px'}
                        />
                        Add New
                      </Button>
                    )}
                  />
                </Col>

                <Col xs={12} sm={8} md={8} lg={8} className="mt-3">
                  <LabelSelector
                    inputProps={{ disabled: !formik.values.trucker_id }}
                    placeholder={'Select Driver'}
                    label={'Driver'}
                    errorProps={{ tooltip: false }}
                    options={{
                      data: driverOptions,
                      formatter: option => ({
                        label: `${option.driver_name}`,
                        value: option.driver_id,
                        desc: option.vehicle_number
                          ? `assigned to ${option.vehicle_number}`
                          : ''
                      })
                    }}
                    controlId={'driver_id'}
                    // controlLabelId={'driver_name'}
                    formik={formik}
                    required
                    allowFooter={true}
                    footerTextBtn={(search, _, setSearch) => (
                      <Button
                        className="text-decoration-none px-3 w-100 text-start"
                        onClick={() => setActiveTab('createDriver')}
                        variant="link"
                      >
                        <Icon
                          icon={'flowbite:circle-plus-solid'}
                          className="me-1"
                          fontSize={'16px'}
                        />
                        Add New
                      </Button>
                    )}
                  />
                </Col>
                {/* <Col className="mt-3" xs={12} sm={6} lg={6}>
                  <LabelInput
                    label={'Driver'}
                    inputProps={{ readOnly: true }}
                    errorProps={{ tooltip: false }}
                    controlId={'driver_name'}
                    required={true}
                    formik={formik}
                  />
                </Col> */}
              </Row>
            </Modal.Body>
          </>
        ) : activeTab == 'createTrucker' ? (
          <CreateQuickTrucker
            show={true}
            handleClose={() => setActiveTab('AllData')}
            handleRefresh={refreshTrucker}
            setId={id => {
              formik.setFieldValue('driver_id', '');
              formik.setFieldValue('vehicle_id', '');
              formik.setFieldValue('trucker_id', id);
              fetchVehicle(id);
              fetchDriver(id);
            }}
          />
        ) : activeTab == 'createVehicle' ? (
          <CreateQuickVehicle
            // refreshData={refreshData}
            show={true}
            handleClose={() => setActiveTab('AllData')}
            truckerId={formik.values.trucker_id}
            handleRefresh={() => fetchVehicle(formik.values.trucker_id)}
            setId={id => {
              formik.setFieldValue('vehicle_id', id);
              fetchDriver(formik.values.trucker_id);
            }}
          />
        ) : activeTab == 'createDriver' ? (
          <CreateQuickDriver
            show={true}
            handleClose={() => setActiveTab('AllData')}
            truckerId={formik.values.trucker_id}
            vehicleId={formik.values.vehicle_id}
            handleRefresh={() => fetchDriver(formik.values.trucker_id)}
            setId={id => {
              formik.setFieldValue('driver_id', id);
            }}
          />
        ) : (
          ''
        )}

        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="phoenix-secondary"
            disabled={loading || activeTab !== 'AllData' ? true : false}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="phoenix-success"
            disabled={fetchLoading || activeTab !== 'AllData' ? true : false}
            onClick={formik.handleSubmit}
          >
            {fetchLoading ? 'Assigning...' : 'Assign'}
          </Button>
        </Modal.Footer>
        <PageLoader loading={loading} loadingMessage={'Assigning vehicle'} />
      </CustomModal>
    </>
  );
};

export default CreateQuickTruckerVehicleDriver;
